import PaymentErrors from './PaymentErrors';

export default PaymentErrors;
